export default __webpack_public_path__ + "static/media/view-pwd.35b68a36.svg";